module.exports = __webpack_public_path__ + "img/ruihong_banner_01.c46996a3.jpg";